import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import Model from '@models/model';

export default class ProposalServiceSchedule extends Model {
    constructor(...props) {
        super();
        this.item = {};
        this.setAttributes(...props);
    }

    resource() {
        return 'service-schedules';
    }

    get formFieldCasts() {
        return {
            labor_rate: CurrencyFormatter.formFormat,
        };
    }
}
